export const sourceGroups = [
  {
    id: "source1",
    groups: ["ind1", "type1", "connect1"]
  },
  {
    id: "source2",
    groups: ["ind1", "type1", "connect2"]
  },
  {
    id: "source3",
    groups: ["ind1", "type2", "connect3"]
  },
  {
    id: "source4",
    groups: ["ind1", "type2", "connect4"]
  },
  {
    id: "source5",
    groups: [
      "ind1",
      "ind2",
      "ind3",
      "type2",
      "type3",
      "type5",
      "connect5",
      "connect7",
      "connect11"
    ]
  },
  {
    id: "source6",
    groups: ["ind1", "ind3", "type2", "type5", "connect6", "connect12"]
  },
  {
    id: "source7",
    groups: ["ind2", "type4", "connect8"]
  },
  {
    id: "source8",
    groups: ["ind2", "type4", "connect9"]
  },
  {
    id: "source9",
    groups: ["ind2", "ind3", "type4", "type5", "connect10", "connect13"]
  },
  {
    id: "source10",
    groups: ["ind3", "type5", "connect14"]
  },
  {
    id: "source11",
    groups: ["ind3", "type5", "connect15"]
  },
  {
    id: "source12",
    groups: ["ind3", "type5", "connect16"]
  },
  {
    id: "source13",
    groups: ["ind3", "type5", "type6", "connect17", "connect18"]
  },
  {
    id: "source14",
    groups: ["ind4", "type8", "connect28"]
  },
  {
    id: "source15",
    groups: ["ind4", "type7", "type8", "connect25", "connect27"]
  },
  {
    id: "source16",
    groups: ["ind3", "ind4", "type6", "type7", "connect19", "connect20"]
  },
  {
    id: "source17",
    groups: ["ind4", "type7", "connect21"]
  },
  {
    id: "source18",
    groups: ["ind4", "type7", "connect22"]
  },
  {
    id: "source19",
    groups: ["ind4", "type7", "connect23"]
  },
  {
    id: "source20",
    groups: ["ind4", "type7", "connect24"]
  },
  {
    id: "source21",
    groups: ["ind4", "type7", "type9", "connect26", "connect29"]
  }
];

export const connectionGroups = [
  {
    id: "connect1",
    groups: ["ind1", "type1", "source1"]
  },
  {
    id: "connect2",
    groups: ["ind1", "type1", "source2"]
  },
  {
    id: "connect3",
    groups: ["ind1", "type2", "source3"]
  },
  {
    id: "connect4",
    groups: ["ind1", "type2", "source4"]
  },
  {
    id: "connect5",
    groups: ["ind1", "type2", "source5"]
  },
  {
    id: "connect6",
    groups: ["ind1", "type2", "source6"]
  },
  {
    id: "connect7",
    groups: ["ind2", "type3", "source5"]
  },
  {
    id: "connect8",
    groups: ["ind2", "type4", "source7"]
  },
  {
    id: "connect9",
    groups: ["ind2", "type4", "source8"]
  },
  {
    id: "connect10",
    groups: ["ind2", "type4", "source9"]
  },
  {
    id: "connect11",
    groups: ["ind3", "type5", "source5"]
  },
  {
    id: "connect12",
    groups: ["ind3", "type5", "source6"]
  },
  {
    id: "connect13",
    groups: ["ind3", "type5", "source9"]
  },
  {
    id: "connect14",
    groups: ["ind3", "type5", "source10"]
  },
  {
    id: "connect15",
    groups: ["ind3", "type5", "source11"]
  },
  {
    id: "connect16",
    groups: ["ind3", "type5", "source12"]
  },
  {
    id: "connect17",
    groups: ["ind3", "type5", "source13"]
  },
  {
    id: "connect18",
    groups: ["ind3", "type6", "source13"]
  },
  {
    id: "connect19",
    groups: ["ind3", "type6", "source16"]
  },
  {
    id: "connect20",
    groups: ["ind4", "type7", "source16"]
  },
  {
    id: "connect21",
    groups: ["ind4", "type7", "source17"]
  },
  {
    id: "connect22",
    groups: ["ind4", "type7", "source18"]
  },
  {
    id: "connect23",
    groups: ["ind4", "type7", "source19"]
  },
  {
    id: "connect24",
    groups: ["ind4", "type7", "source20"]
  },
  {
    id: "connect25",
    groups: ["ind4", "type7", "source15"]
  },
  {
    id: "connect26",
    groups: ["ind4", "type7", "source21"]
  },
  {
    id: "connect27",
    groups: ["ind4", "type8", "source15"]
  },
  {
    id: "connect28",
    groups: ["ind4", "type8", "source14"]
  },
  {
    id: "connect29",
    groups: ["ind4", "type9", "source21"]
  }
];

export const datatypeGroups = [
  {
    id: "type1",
    groups: ["ind1", "source1", "source2", "connect1", "connect2"]
  },
  {
    id: "type2",
    groups: [
      "ind1",
      "source3",
      "source4",
      "source5",
      "source6",
      "connect3",
      "connect4",
      "connect5",
      "connect6"
    ]
  },
  {
    id: "type3",
    groups: ["ind2", "source5", "connect7"]
  },
  {
    id: "type4",
    groups: [
      "ind2",
      "source7",
      "source8",
      "source9",
      "connect8",
      "connect9",
      "connect10"
    ]
  },
  {
    id: "type5",
    groups: [
      "ind3",
      "source5",
      "source6",
      "source9",
      "source10",
      "source11",
      "source12",
      "source13",
      "connect11",
      "connect12",
      "connect13",
      "connect14",
      "connect15",
      "connect16",
      "connect17"
    ]
  },
  {
    id: "type6",
    groups: ["ind3", "source13", "source16", "connect18", "connect19"]
  },
  {
    id: "type7",
    groups: [
      "ind4",
      "source15",
      "source16",
      "source17",
      "source18",
      "source19",
      "source20",
      "source21",
      "connect20",
      "connect21",
      "connect22",
      "connect23",
      "connect24",
      "connect25",
      "connect26"
    ]
  },
  {
    id: "type8",
    groups: ["ind4", "source14", "source15", "connect27", "connect28"]
  },
  {
    id: "type9",
    groups: ["ind4", "source21", "connect29"]
  }
];

export const indicatorGroups = [
  {
    id: "ind1",
    groups: [
      "type1",
      "type2",
      "source1",
      "source2",
      "source3",
      "source4",
      "source5",
      "source6",
      "connect1",
      "connect2",
      "connect3",
      "connect4",
      "connect5",
      "connect6"
    ]
  },
  {
    id: "ind2",
    groups: [
      "type3",
      "type4",
      "source5",
      "source7",
      "source8",
      "source9",
      "connect7",
      "connect8",
      "connect9",
      "connect10"
    ]
  },
  {
    id: "ind3",
    groups: [
      "type5",
      "type6",
      "source5",
      "source6",
      "source9",
      "source10",
      "source11",
      "source12",
      "source13",
      "source16",
      "connect11",
      "connect12",
      "connect13",
      "connect14",
      "connect15",
      "connect16",
      "connect17",
      "connect18",
      "connect19"
    ]
  },
  {
    id: "ind4",
    groups: [
      "type7",
      "type8",
      "type9",
      "source14",
      "source15",
      "source16",
      "source17",
      "source18",
      "source19",
      "source20",
      "source21",
      "connect20",
      "connect21",
      "connect22",
      "connect23",
      "connect24",
      "connect25",
      "connect26",
      "connect27",
      "connect28",
      "connect29"
    ]
  }
];
